import { Button, Offcanvas } from "react-bootstrap";
import ShareWithMember from "./ShareWithMember";
import ShareWithGroup from "./ShareWithGroup";
import { useEffect, useState } from "react";
import { TbUserShare } from "react-icons/tb";
import { MdOutlineCategory } from "react-icons/md";

const ShareList = ({ Show, Hide, itemData, isDark, Title, auth }) => {
  const [shareWith, setShareWith] = useState("shareWithMember");
  const RadioCard = ({ icon, label, active, onClick }) => (
    <div
      onClick={onClick}
      className={`p-2 rounded-2 border CP mb-2 w-100 text-center ${active ? "border-primary bg-primary bg-opacity-10" : "border-secondary"}`}
      style={{ fontSize: 12, fontWeight: 600 }}
    >
      {icon} {label}
    </div>
  );

  useEffect(() => {
    if (Show) {
      setShareWith("shareWithMember")
    }
  }, [Show]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header
        closeButton
        className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}
      >
        <Offcanvas.Title
          className="fw-bold hstack gap-2"
          style={{ fontSize: 15 }}
        >
          <img
            src={itemData?.categoryIcon}
            alt={itemData?.categoryName}
            style={{
              width: 25,
              height: 25,
              objectFit: "contain",
            }}
          />
          <span>{itemData?.categoryName} {Title}</span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        {itemData?.groupId !== "personal" &&
          <div className="hstack gap-2 p-2">
            <RadioCard
              icon={<TbUserShare className="me-1" />}
              label="Share with Members"
              active={shareWith === "shareWithMember"}
              onClick={() => setShareWith("shareWithMember")}
            />
            <RadioCard
              icon={<MdOutlineCategory className="me-1" />}
              label="Share with Groups"
              active={shareWith === "shareWithGroup"}
              onClick={() => setShareWith("shareWithGroup")}
            />
          </div>
        }
        {shareWith === "shareWithMember" && (
          <ShareWithMember Show={Show} auth={auth} itemData={itemData} />
        )}
        {(shareWith === "shareWithGroup" && itemData?.groupId !== "personal") && (
          <ShareWithGroup Show={Show} auth={auth} itemData={itemData} />
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShareList;
